/**
 * prefix：站点根；组件默认 `DEFAULT_SITE_PREFIX`。
 * 传 `/` 或空字符串表示当前源站相对路径。
 */

/** 默认站点根（菜单链接、Logo 跳转等未传 prefix 时使用） */
export const DEFAULT_SITE_PREFIX = 'https://www.comake.online'

/** 默认 Logo 图片地址（未传 logo-src 时使用） */
export const DEFAULT_LOGO_SRC = `${DEFAULT_SITE_PREFIX}/_nuxt/comake-logo.CB2R6b60.png`

/** 客服 Widget API（组件内写死，无需外部传入） */
export const CS_API_URL = 'https://dev.comake.online/custom_service'

/** 问题反馈跳转地址（论坛说明帖） */
export const FEEDBACK_URL = 'https://dev.comake.online/home/article/10578'

export function normalizePrefix(prefix?: string): string {
  if (!prefix || prefix === '/') return ''
  return prefix.replace(/\/$/, '')
}

/** prefix_except_default：zh 无前缀，en 加 /en */
export function buildMenuPath(path: string, lang: string, prefix?: string): string {
  const base = normalizePrefix(prefix)
  const localePath = lang === 'en' ? `/en${path}` : path
  return base ? `${base}${localePath}` : localePath
}

/** 将菜单 key 转为可与 location.pathname 比较的相对路径 */
export function linkKeyForActiveMatch(key: string, prefix?: string): string {
  const base = normalizePrefix(prefix)
  if (base && key.startsWith(base)) {
    const rest = key.slice(base.length)
    return (rest.split('?')[0] || '/')
  }
  return key.split('?')[0] || '/'
}

/**
 * 按 prefix_except_default 规则，把当前 pathname 切换到目标语言路径。
 * 已是目标语言时返回 null（无需跳转）。
 */
export function localePathForSwitch(
  pathname: string,
  targetLang: string
): string | null {
  const hasEn = pathname === '/en' || pathname.startsWith('/en/')
  if (targetLang === 'en') {
    if (hasEn) return null
    return pathname === '/' ? '/en' : `/en${pathname}`
  }
  if (targetLang === 'zh') {
    if (!hasEn) return null
    if (pathname === '/en') return '/'
    const stripped = pathname.replace(/^\/en/, '')
    return stripped || '/'
  }
  return null
}

/** 论坛等无 /en 路径的站点：语言切换仅更新菜单文案，不跳转 */
export function isLocaleLabelOnlyOrigin(): boolean {
  if (typeof window === 'undefined') return false
  return window.location.hostname.includes('dev.comake.online')
}

/** 本站语言切换：更新地址栏到对应语言路径（外站 prefix 时跳转到该域名） */
export function applySiteLocaleSwitch(targetLang: string, prefix?: string): boolean {
  if (typeof window === 'undefined') return false
  if (isLocaleLabelOnlyOrigin()) return false
  const nextPath = localePathForSwitch(window.location.pathname, targetLang)
  if (!nextPath) return false

  const { search, hash } = window.location
  const base = normalizePrefix(prefix)
  const href = base
    ? `${base}${nextPath}${search}${hash}`
    : `${nextPath}${search}${hash}`
  window.location.assign(href)
  return true
}
